import gql from 'graphql-tag';
import { ACCOUNT_CONTACT_FRAGMENT } from './fragment';

export const DELETE_ACCOUNT_CONTACT = gql`
  ${ACCOUNT_CONTACT_FRAGMENT}
  mutation DeleteAccountContact($input: DeleteAccountContactInput!) {
    accountMutation {
      result: deleteAccountContact(input: $input) {
        success
        error
        entity {
          ...AccountContactFields
        }
      }
    }
  }
`;
